import React from 'react';
import Bskimg from "../assets/bskofficial.png"

const Instagram = () => {
  const profile = {
    followers: '147K',
    // image: bskImage
  };

  return (
    <div className="insta-container">
      <div>
        <h1 className="jumbo-heading">BSK BOUTIQUE</h1>
      </div>
      <div>
        <p className=" section-text mb-4">
           BSK Boutique has been my valued client for years,
            and their journey is truly inspiring. 
            What started as a simple passion for home-made, handcrafted products has grown into a trusted brand with over 150K loyal Instagram followers. 
            Their customers believe in them because every product carries genuine quality, effort, and love. For more than 7 years, BSK Boutique has been setting a benchmark in this field—offering premium, unique, and thoughtfully created items that stand out in both design and durability. Their commitment to excellence, customer trust, and consistent innovation has helped them build a strong community that continues to grow every single day. BSK Boutique is not just a brand; it’s a reflection of dedication, trust, and true craftsmanship.
          </p>
        </div>

      <img src={Bskimg} alt="Profile" className="insta-profile-img" />
      <p className="insta-followers">{profile.followers} Followers</p>

      <button className="insta-follow-btn">
        <a
          className="text-decoration-none text-white"
          href="https://www.instagram.com/bskboutique?igsh=MWkwcXR0ajE1Z3E2MA=="
          target="blank"
        >
          Follow
        </a>
      </button>
    </div>
  );
};

export default Instagram;
